// extracted by mini-css-extract-plugin
module.exports = {"displayCard":"styles_displayCard__94gE1","icon":"styles_icon__50Iej"};